import { usePageData } from 'pages/categories/CategoryPage/components/PageDataProvider/PageDataProvider'

export const CategoryPageBrowseText = ({
  defaultText,
}: {
  defaultText: string
}) => {
  const { category } = usePageData()
  const title = category?.name ?? defaultText

  return <span>{title}</span>
}
